<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Mensajes enviados</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <!--   <vue-json-to-csv
            :json-data="itemsToExport"
            :csv-title="'empleados-' + new Date().valueOf()"
            :labels="labels"
            style="visibility: hidden"
          >
           
            <base-button size="sm" type="neutral" ref="myBtn"
              >Exportar</base-button
            >
          </vue-json-to-csv> -->
          <base-button size="sm" type="neutral" @click="addTipo()"
            >Nuevo mensaje</base-button
          >
          <!--   <base-button
            size="sm"
            type="neutral"
            @click="exportData()"
            :loading="loading"
            >Exportar</base-button
          > -->
        </div>
      </div>
      <!-- Card stats -->
      <div class="row pt-1">
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="De sistema"
            type="gradient-green"
            :sub-title="totalSistema ? totalSistema.toString() : '0'"
            icon="ni ni-money-coins"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalSistema
                    ? Math.floor((totalSistema * 100) / totalAvisos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los avisos</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="De incidencia"
            type="gradient-orange"
            :sub-title="totalIncidencia ? totalIncidencia.toString() : '0'"
            icon="ni ni-chart-pie-35"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalIncidencia
                    ? Math.floor((totalIncidencia * 100) / totalAvisos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los avisos</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="De revisión"
            type="gradient-red"
            :sub-title="totalRevision ? totalRevision.toString() : '0'"
            icon="ni ni-active-40"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalRevision
                    ? Math.floor((totalRevision * 100) / totalAvisos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los avisos</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Mensajes directos"
            type="gradient-red"
            :sub-title="totalDirectos ? totalDirectos.toString() : '0'"
            icon="ni ni-active-40"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalDirectos
                    ? Math.floor((totalDirectos * 100) / totalAvisos)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los avisos</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="row p-3">
              <div class="col-md-4">
                <div>
                  <form>
                    <base-input
                      v-model="query"
                      type="search"
                      prepend-icon="fas fa-search"
                      placeholder="Buscar por mensaje"
                      clearable
                    />
                  </form>
                </div>
              </div>
              <div class="col-md-8">
                <div
                  class="d-flex justify-content-right justify-content-sm-end"
                >
                  <div>
                    <div class="row">
                      <div class="col pr-1">
                        <base-input label="">
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur"
                            :config="configInput"
                            class="form-control datepicker"
                            v-model="fdesde"
                            placeholder="Fecha desde..."
                          >
                          </flat-picker>
                        </base-input>
                      </div>
                      <div class="col pl-0">
                        <base-input label="">
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur"
                            :config="configInput"
                            class="form-control datepicker"
                            v-model="fhasta"
                            placeholder="Fecha hasta..."
                          >
                          </flat-picker>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pl-5 pt-2 pb-4" v-if="notificaciones.length > 0">
              <time-line type="one-side">
                <time-line-item
                  :badge-type="
                    notif.tipo_notificacion.data.attributes.descripcion ==
                    'revision'
                      ? 'greenlight'
                      : notif.tipo_notificacion.data.attributes.descripcion ==
                        'mensaje_directo'
                      ? 'info'
                      : 'danger'
                  "
                  :badge-icon="
                    notif.tipo_notificacion.data.attributes.descripcion ==
                    'revision'
                      ? 'ni ni-settings'
                      : notif.tipo_notificacion.data.attributes.descripcion ==
                        'incidencia'
                      ? 'ni ni-ambulance'
                      : 'ni ni-send'
                  "
                  v-for="(notif, key, index) in notificaciones"
                  :key="notif.id"
                >
                  <badge
                    rounded
                    :type="
                      notif.tipo_notificacion.data.attributes.descripcion ==
                      'revision'
                        ? 'greenlight'
                        : notif.tipo_notificacion.data.attributes.descripcion ==
                          'mensaje_directo'
                        ? 'info'
                        : 'danger'
                    "
                    >{{
                      notif.tipo_notificacion.data.attributes.descripcion ==
                      "mensaje_directo"
                        ? "Mensaje directo"
                        : notif.tipo_notificacion.data.attributes.descripcion
                    }}</badge
                  >
                  <div class="mt-3">
                    <small class="text-muted font-weight-bold">
                      {{ moment(notif.createdAt).format("DD/MM/YYYY HH:mm") }}
                      ({{ moment(notif.createdAt).fromNow() }})
                    </small>
                  </div>

                  <!--  MENSAJE DIRECTO -->
                  <div
                    v-if="
                      notif.tipo_notificacion.data.attributes.descripcion ==
                      'mensaje_directo'
                    "
                  >
                    <h5 class="text-muted" style="margin: 0">Enviado a:</h5>
                    <ul>
                      <li
                        v-for="(noti, index) in notif.usuario_destinos.data"
                        :key="'noti' + index"
                        class="text-muted"
                      >
                        <h5 class="text-muted" style="margin: 0">
                          {{ noti.attributes.nombre }}
                          {{ noti.attributes.apellidos }}
                          <b>({{ noti.attributes.email }})</b>
                        </h5>
                      </li>
                    </ul>
                    <h5 class="text-muted">Mensaje:</h5>
                    <h4 class="m-0">{{ notif.descripcion }}</h4>
                    <br />
                  </div>

                  <!-- REVISION -->
                  <div
                    v-if="
                      notif.tipo_notificacion.data.attributes.descripcion ==
                      'revision'
                    "
                  >
                    <h5 class="mt-3 mb-0">
                      Solicitud de revisión enviada al personal de Misepis.
                    </h5>
                    <br />
                    <h5>Equipos enviados para revisión:</h5>
                    <h5 v-html="notif.activos"></h5>
                    <h5 class="mt-3 mb-0">{{ notif.descripcion }}</h5>
                  </div>

                  <!-- INCIDENCIA -->
                  <div
                    v-if="
                      notif.tipo_notificacion.data.attributes.descripcion ==
                      'incidencia'
                    "
                  >
                    <h5 class="text-muted" style="margin: 0">Enviado a:</h5>
                    <ul>
                      <li
                        v-for="(noti, index) in notif.usuario_destinos.data"
                        :key="'noti' + index"
                        class="text-muted"
                      >
                        <h5 class="text-muted" style="margin: 0">
                          {{ noti.attributes.nombre }}
                          {{ noti.attributes.apellidos }}
                          <b>({{ noti.attributes.email }})</b>
                        </h5>
                      </li>
                    </ul>
                    <h5 class="text-muted">Mensaje:</h5>
                    <h4 class="m-0">{{ notif.descripcion }}</h4>
                    <br />
                    <h5 v-html="notif.activos"></h5>
                    <router-link
                      :to="notif.url"
                      class="dropdown-item text-center text-primary font-weight-bold py-3"
                      >Ver incidencia</router-link
                    >
                  </div>
                </time-line-item>
              </time-line>
            </div>
            <div class="pl-5 pt-2 pb-4" v-else>
              <h5>
                No hay mensajes que mostrar. Aún no has enviado ningún mensaje.
              </h5>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "@/components/";

import { TimeLine, TimeLineItem } from "@/components";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import Badge from "@/components/Badge";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
moment.locale("es");

import { Spanish } from "flatpickr/dist/l10n/es.js";

export default {
  layout: "DashboardLayout",

  components: {
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    Badge,
    BaseHeader,
    TimeLine,
    TimeLineItem,
  },

  data() {
    return {
      query: null,
      revisiones: [],
      selectedRows: [],
      sort: "createdAt:desc",

      configInput: {
        allowInput: true,
        dateFormat: "d-m-Y",
        locale: Spanish, // locale for this instance only
      },
      fdesde: null,
      fhasta: null,

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },

      totalAvisos: 0,
      totalSistema: 0,
      totalIncidencia: 0,
      totalRevision: 0,
      totalDirectos: 0,

      total: 0,
      loading: true,
      notificaciones: [],
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    fdesde: {
      handler: "getListDebounced",
      immediate: true,
    },
    fhasta: {
      handler: "getListDebounced",
      immediate: true,
    },
    prioridad: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);

      var filters = {
        $and: [
          {
            usuario_origen: {
              id: { $in: profile.id },
            },
          },
          { $or: [] },
        ],
      };

      if (this.query) {
        console.log(filters["$and"][1]["$or"]);

        filters["$and"][1]["$or"].push({
          descripcion: { $containsi: this.query },
        });
      }

      if (this.fdesde) {
        var newdate = this.fdesde.split("-").reverse().join("-");
        filters["$and"].push({
          createdAt: { $gt: newdate },
        });
      }

      if (this.fhasta) {
        var newdate = this.fhasta.split("-").reverse().join("-");
        filters["$and"].push({
          createdAt: { $lt: newdate },
        });
      }

      let params = {
        filters: filters,
      };
      await this.$store.dispatch("notificaciones/list", params).then(() => {
        this.notificaciones = this.$store.getters["notificaciones/list"];

        console.log("NOTIFICACIONES: ");
        console.log(this.notificaciones);

        this.total = this.$store.getters["notificaciones/listTotal"];
        if (this.total > this.totalAvisos) {
          this.totalAvisos = this.total;
        }
      });

      var filtersSistema = {
        $and: [
          {
            usuario_origen: {
              id: { $in: profile.id },
            },
          },
          {
            tipo_notificacion: {
              id: { $in: 1 },
            },
          },
        ],
      };
      await this.$store
        .dispatch("notificaciones/list", {
          filters: filtersSistema,
        })
        .then(() => {
          this.totalSistema = this.$store.getters["notificaciones/listTotal"];
        });

      var filtersIncidencias = {
        $and: [
          {
            usuario_origen: {
              id: { $in: profile.id },
            },
          },
          {
            tipo_notificacion: {
              id: { $in: 2 },
            },
          },
        ],
      };
      await this.$store
        .dispatch("notificaciones/list", {
          filters: filtersIncidencias,
        })
        .then(() => {
          this.totalIncidencia =
            this.$store.getters["notificaciones/listTotal"];
        });

      var filtersRevision = {
        $and: [
          {
            usuario_origen: {
              id: { $in: profile.id },
            },
          },
          {
            tipo_notificacion: {
              id: { $in: 3 },
            },
          },
        ],
      };
      await this.$store
        .dispatch("notificaciones/list", {
          filters: filtersRevision,
        })
        .then(() => {
          this.totalRevision = this.$store.getters["notificaciones/listTotal"];
        });

      var filtersDirectos = {
        $and: [
          {
            usuario_origen: {
              id: { $in: profile.id },
            },
          },
          {
            tipo_notificacion: {
              id: { $in: 5 },
            },
          },
        ],
      };
      await this.$store
        .dispatch("notificaciones/list", {
          filters: filtersDirectos,
        })
        .then(() => {
          this.totalDirectos = this.$store.getters["notificaciones/listTotal"];
        });

      this.loading = false;
    },

    async deleteTipo(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default empresa.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Eliminar esta incidencia?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "No, mantenerla",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("incidencias/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Incidencias eliminada correctamente.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "This Empresa still has associated Items.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
    addTipo() {
      this.$router.push({ name: "Add notificacion" });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit notificacion",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else {
        this.sort = `${prop}:asc`;
      }
      this.getList();
    },
  },
};
</script>
